var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',[_vm._v("PromotionalArea")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }